module.exports = __webpack_public_path__ + "assets/img/13_990.ae1a4433.jpg";